import {
  LINK_METADATA_ACCOUNT_ID_FIELD_OPTION,
  LINK_METADATA_USER_ID_FIELD_OPTION,
} from '@modules/integrationsV2/constants';
import {
  MetadataFieldRelationByIntegrationType,
  MetadataFieldRelationValueByType,
} from '@modules/integrationsV2/store/types';
import { IntegrationSource } from '@modules/integrationsV2/types';
import { EqlField, FieldRelation, IntegrationType } from 'generated/graphql';

interface GetIntegrationMetadataFieldRelationsByTypeParams {
  fieldRelations: FieldRelation[];
  allEqlFields: EqlField[];
}

// Not moving in new file, because it's temporary solution, will be removed in future
export const getEqlFieldTypeFromStringField = (
  field: string,
  allEqlFields: EqlField[],
  integrationSource?: IntegrationSource,
): EqlField | undefined => {
  if (field === LINK_METADATA_USER_ID_FIELD_OPTION.field) {
    return integrationSource
      ? {
          ...LINK_METADATA_USER_ID_FIELD_OPTION,
          iconURL: integrationSource.channel.logo,
          detail: {
            metadata: {
              source: integrationSource.channel.displayName,
            },
          },
        }
      : LINK_METADATA_USER_ID_FIELD_OPTION;
  }

  if (field === LINK_METADATA_ACCOUNT_ID_FIELD_OPTION.field) {
    return integrationSource
      ? {
          ...LINK_METADATA_ACCOUNT_ID_FIELD_OPTION,
          iconURL: integrationSource.channel.logo,
          detail: {
            metadata: {
              source: integrationSource.channel.displayName,
            },
          },
        }
      : LINK_METADATA_ACCOUNT_ID_FIELD_OPTION;
  }

  return allEqlFields.find((eqlField) => eqlField.field === field);
};

export const getMetadataFieldRelationsByIntegrationType = ({
  fieldRelations,
  allEqlFields,
}: GetIntegrationMetadataFieldRelationsByTypeParams): MetadataFieldRelationByIntegrationType[] => {
  if (!fieldRelations.length || !allEqlFields.length) {
    return [];
  }

  const fieldRelationsByType: MetadataFieldRelationByIntegrationType[] = [];

  fieldRelations.forEach((fieldRelation) => {
    const field1 = getEqlFieldTypeFromStringField(
      fieldRelation.field1,
      allEqlFields,
    );
    const field2 = getEqlFieldTypeFromStringField(
      fieldRelation.field2,
      allEqlFields,
    );

    if (field1 && field2) {
      const relationByType: MetadataFieldRelationByIntegrationType = {
        [IntegrationType.Feedback]: getFieldRelationsValueByType({
          field1,
          field2,
          integrationType: IntegrationType.Feedback,
        }),
        [IntegrationType.User]: getFieldRelationsValueByType({
          field1,
          field2,
          integrationType: IntegrationType.User,
        }),
        [IntegrationType.Account]: getFieldRelationsValueByType({
          field1,
          field2,
          integrationType: IntegrationType.Account,
        }),
        [IntegrationType.Cohorts]: null, // TODO: Add when cohort type is added to ObjectType
        [IntegrationType.Comms]: null, // Not supported, adding here to avoid type errors
        [IntegrationType.MetadataEnrichment]: null, // Not supported, adding here to avoid type errors
      };

      fieldRelationsByType.push(relationByType);
    }
  });

  return fieldRelationsByType;
};

const getFieldRelationsValueByType = ({
  field1,
  field2,
  integrationType,
}: {
  field1: EqlField;
  field2: EqlField;
  integrationType: IntegrationType;
}): MetadataFieldRelationValueByType | null => {
  const fieldByType =
    field1.objectType.toString() === integrationType.toString()
      ? field1
      : field2.objectType.toString() === integrationType.toString()
      ? field2
      : null;

  if (!fieldByType) {
    return null;
  }

  return {
    field: fieldByType.field,
    source: fieldByType.detail?.metadata?.source ?? '',
  };
};
